export default __webpack_public_path__ + "static/media/rss_feed.fbe0b5af.svg";